export default "__VITE_PUBLIC_ASSET__c3fc1f10__"